<template>
  <LogoWrapper
    :src="src"
    alt="Stake: Your Voice through Your Investments"
    :max-height="maxHeight"
    :max-width="maxWidth"
  />
</template>


<script>
import LogoWrapper from './LogoWrapper.vue';

export default {
  name: 'ComponentName',
  components: { LogoWrapper },
  props: {
    maxHeight: { type: Number },
    maxWidth: { type: Number },
  },
  data() {
    return {

    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    src() {
      return this.$root.$data.STATIC_ROOT + 'images/yourstakelogo.png';
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {

  },
};
</script>
